module.exports = __webpack_public_path__ + "img/act_pro_img0s_03.4b5ed7a6.png";